module.exports = __webpack_public_path__ + "media/arbutin-small.a0325f7c.mp4";